// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"3778513c","409":"359df54c","411":"8bde3479","422":"e2d94864","621":"ef797a96","724":"a2db3e15","775":"f91a9a3a","787":"2c6aae43","830":"a8c35ed2","863":"d5a23a3d","930":"00e5e0b2","939":"08d5565d","985":"8fb3b356"}[chunkId] + ".chunk.js";
};